import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
  Drawer,
  InputBase,
} from "@mui/material";
import { Box, TextField } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseDiscountCode } from "./UseDiscountCode";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsGotoLast, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import { UseMyPC } from "../../../hooks/UseMyPC";
import { deCapitalizeFirstLetter } from "../../../util/Utils";
import { useLocation } from "react-router-dom";
import CodeSMS from "./CodeSMS";

export default function CodeUser(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const {
    getDiscountCodeUser,
    deleteAllDiscountCodeUser,
    addDiscountCodeUsers,
    deleteDiscountCodeUser,
  } = UseDiscountCode();
  const [users, setUsers] = useState([]);
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [usersLength, setUsersLength] = useState();
  const [allUserDelete, setAllUserDelete] = useState(false);
  const [addUsersList, setAddUsersList] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    discountID: props.DiscountID,
    mobile: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [search, setSearch] = useState("");
  const [searchState, setSearchState] = useState("");

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getDiscountCodeUser(myPc, search, props.DiscountID, (users) => {
      if (msGotoLast) {
        setMsGotoLast(false);
        goToLastPage(users.pageCondition.totalPage);
        return;
      }
      setUsers(users);
    });
  }, [myPc, props.DiscountID]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "mobile",
      width: 150,
      align: "center",
      headerName: "شماره",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.mobile,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addUser",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton onClick={() => setAddUsersList(true)}>
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
    {
      field: "deleteAll",
      width: 100,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              setAllUserDelete(true);
              setDeleteState({
                show: true,
                name: " همه کاربران ",
                id: props.DiscountID,
              });
            }}
          >
            حذف همه
          </Button>
        );
      },
    },
  ];

  return (
    <Dialog
      sx={{ zIndex: 200 }}
      fullWidth
      maxWidth="md"
      open={props.showUser}
      //   onClose={() => props.setShowUser(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography color="secondary" variant="subtitle2">
            لیست کاربران
          </Typography>
          <IconButton
            onClick={() => {
              props.setShowUser(false);
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ height: "25rem" }}>
          {users && users.mobile ? (
            <DataGrid
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={users.pageCondition.pageCount}
              rows={users.mobile}
              paginationMode="server"
              page={users.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                users?.pageCondition.totalItemCount
                  ? users.pageCondition.totalItemCount
                  : 1
              }
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  nofab: true,
                  rowCount: users?.pageCondition.totalItemCount
                    ? users.pageCondition.totalItemCount
                    : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
        <CodeSMS
          length={users?.pageCondition?.totalItemCount}
          DiscountID={props.DiscountID}
        />
        <Drawer
          anchor="bottom"
          open={addUsersList}
          onClose={() => {
            setUsersLength();
            setAddUsersList(false);
            setStateAdd({ ...stateAdd, mobile: "" });
          }}
          sx={{
            "&  .MuiDrawer-paper": {
              zIndex: 100000,
              // height: "60%",
              width: "30%",
              mx: "auto",
              borderRadius: 3,
              borderBottomRightRadius: 0,
              borderBottomLeftRadius: 0,
              p: 2,
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              // justifyContent: "center",
            },
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <Typography mb={2} variant="span2">
            کاربر/ کاربران را وارد کنید
          </Typography>
          <TextField
            autoFocus
            // focused
            // inputRef={addBarcodTF}
            label="کاربر/ کاربران"
            rows={8}
            sx={{ width: "100%" }}
            multiline
            type="number"
            value={stateAdd.mobile ? stateAdd.mobile : ""}
            onChange={(event) => {
              if (event.target.value) {
                setStateAdd({
                  discountID: props.DiscountID,
                  mobile: event.target.value,
                });
              } else {
                setStateAdd({
                  discountID: props.DiscountID,
                  mobile: event.target.value,
                });
                setUsersLength(0);
              }
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                if (!stateAdd.mobile.length || stateAdd.mobile.length < 11) {
                  enqueueSnackbar("شماره ها را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                var phoneNumbersArray = stateAdd.mobile.split(",");
                let newModel = {
                  discountID: stateAdd.discountID,
                  mobile: phoneNumbersArray,
                };
                setProgress(true);
                addDiscountCodeUsers(newModel, () => {
                  getDiscountCodeUser(
                    myPc,
                    search,
                    stateAdd.discountID,
                    (users) => {
                      setUsers(users);
                    }
                  );
                  setUsersLength(0);
                  props.callback(props.DiscountID);
                  setAddUsersList(false);
                  setStateAdd({ ...stateAdd, mobile: "" });
                });
              }
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mt: 2,
            }}
          >
            <Typography>
              تعداد کاربر : {usersLength ? usersLength : 0}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Button
                disabled={stateAdd.mobile.length ? false : true}
                variant="contained"
                color="secondary"
                onClick={() => {
                  var phoneNumbersArray = stateAdd.mobile.split(",");
                  let temp = [];
                  phoneNumbersArray.map((mobile) => {
                    if (mobile.length == 11) {
                      temp.push(mobile);
                    }
                  });
                  setUsersLength(temp.length);
                }}
              >
                محاسبه
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  if (!stateAdd.mobile.length || stateAdd.mobile.length < 11) {
                    enqueueSnackbar("شماره ها را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  var phoneNumbersArray = stateAdd.mobile.split(",");
                  let newModel = {
                    discountID: stateAdd.discountID,
                    mobile: phoneNumbersArray,
                  };
                  setProgress(true);
                  addDiscountCodeUsers(newModel, () => {
                    getDiscountCodeUser(
                      myPc,
                      search,
                      stateAdd.discountID,
                      (users) => {
                        setUsers(users);
                      }
                    );
                    setUsersLength(0);
                    props.callback(props.DiscountID);
                    setAddUsersList(false);
                    setStateAdd({ ...stateAdd, mobile: "" });
                  });
                }}
              >
                ثبت
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setUsersLength(0);
                  setAddUsersList(false);
                  setStateAdd({ ...stateAdd, mobile: "" });
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </Drawer>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={""}
          callback={() => {
            setProgress(true);
            if (allUserDelete) {
              deleteAllDiscountCodeUser(deleteState.id, () => {
                setAllUserDelete(false);
                getDiscountCodeUser(myPc, search, props.DiscountID, (users) => {
                  props.callback(props.DiscountID);
                  setUsers(users);
                });
              });
            } else {
              deleteDiscountCodeUser(deleteState.id, () => {
                getDiscountCodeUser(myPc, search, props.DiscountID, (users) => {
                  props.callback(props.DiscountID);
                  setUsers(users);
                });
              });
            }
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
